import { createAsyncThunk } from '@reduxjs/toolkit';
import { Object as FabricObject } from 'fabric/fabric-impl';
import { mediaManagerRepository } from 'modules/manager/domain/repositories';
import { MediaManagerBoard, MediaManagerTemplate } from 'modules/manager/domain/interfaces';

export interface FetchBoardForEditorArgs {
  templateId: number;
  boardId: number;
}

export interface FetchBoardForEditorResult {
  template: MediaManagerTemplate;
  board: MediaManagerBoard;
}

export const fetchBoardForEditor = createAsyncThunk<FetchBoardForEditorResult, FetchBoardForEditorArgs>(
  'manager/fetchBoardForEditor',
  async ({ templateId, boardId }) => {
    const { template, boards } = await mediaManagerRepository.getTemplateWithBoards(templateId);
    const board = boards.find((b) => b.id === boardId);
    if (!board) throw new Error(`Board ${boardId} not found in template ${templateId}`);
    return { template, board };
  },
);

export const fetchBoardOnly = createAsyncThunk<MediaManagerBoard, { boardId: number }>(
  'manager/fetchBoardOnly',
  async ({ boardId }) => {
    return mediaManagerRepository.getBoardById(boardId);
  },
);

export interface SaveBoardArgs {
  id: number;
  objects: FabricObject[];
  version: string;
}

export const saveBoard = createAsyncThunk<MediaManagerBoard, SaveBoardArgs>('manager/saveBoard', async ({ id, objects, version }) => {
  return mediaManagerRepository.updateBoardObjects({ id, objects, version });
});
